<script lang="ts">
  import type { Snippet } from 'svelte';

  type Tone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'admin' | 'user' | 'client';

  let {
    tone = 'neutral',
    class: className = '',
    children,
  }: {
    tone?: Tone;
    class?: string;
    children: Snippet;
  } = $props();
</script>

<span class="badge tone-{tone} {className}">{@render children()}</span>

<style>
  .badge {
    display: inline-flex;
    align-items: center;
    gap: var(--space-1);
    height: 1.5rem;
    padding: 0 var(--space-2);
    border-radius: var(--radius-pill);
    font-size: var(--text-xs);
    font-weight: var(--weight-medium);
    letter-spacing: 0.02em;
    border: 1px solid transparent;
    text-transform: uppercase;
  }

  .tone-neutral {
    background: var(--surface-2);
    color: var(--text-secondary);
    border-color: var(--border);
  }

  .tone-accent {
    background: var(--accent-muted);
    color: var(--accent-strong);
    border-color: color-mix(in srgb, var(--accent) 30%, transparent);
  }

  .tone-success {
    background: var(--success-muted);
    color: var(--success);
  }

  .tone-warning {
    background: var(--warning-muted);
    color: var(--warning);
  }

  .tone-danger {
    background: var(--danger-muted);
    color: var(--danger);
  }

  .tone-admin {
    background: color-mix(in srgb, var(--role-admin) 16%, transparent);
    color: var(--role-admin);
  }

  .tone-user {
    background: color-mix(in srgb, var(--role-user) 16%, transparent);
    color: var(--role-user);
  }

  .tone-client {
    background: color-mix(in srgb, var(--role-client) 16%, transparent);
    color: var(--role-client);
  }
</style>
